export const dividendsTypes = {
    FC: 'FC',
    TC: 'TC',
};

export const pricesTypes = {
    SP: 'SP',
    LP: 'LP',
};
